const AddPermissionModal = () => {};

export default AddPermissionModal;
